import { render, staticRenderFns } from "./view-attachments.vue?vue&type=template&id=37a8cf7e&scoped=true"
import script from "./view-attachments.vue?vue&type=script&lang=js"
export * from "./view-attachments.vue?vue&type=script&lang=js"
import style0 from "./view-attachments.vue?vue&type=style&index=0&id=37a8cf7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a8cf7e",
  null
  
)

export default component.exports